export type OpenSourcePR = {
  title: string;
  url: string;
  description?: string;
  date?: string;
};

export type OpenSourceProject = {
  name: string;
  repoUrl?: string;
  prs: OpenSourcePR[];
};

export const openSourceProjects: OpenSourceProject[] = [
  {
    name: "localstack/localstack",
    repoUrl: "https://github.com/localstack/localstack",
    prs: [
      {
        title: "fix(dynamodbstreams): support ShardFilter on DescribeStream",
        url: "https://github.com/localstack/localstack/pull/13670",
        description: "Implements support for the CHILD_SHARDS ShardFilter type so DescribeStream returns only shards whose ParentShardId matches the given shard ID.",
        date: "2026-01",
      },
    ],
  },
];
